import { render } from "./EmailVerificationView.vue?vue&type=template&id=0656cd10&scoped=true"
import script from "./EmailVerificationView.vue?vue&type=script&lang=js"
export * from "./EmailVerificationView.vue?vue&type=script&lang=js"

import "./EmailVerificationView.vue?vue&type=style&index=0&id=0656cd10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0656cd10"]])

export default __exports__